import { render, staticRenderFns } from "./card-banner-gatorz.vue?vue&type=template&id=2a17ff94&scoped=true&"
import script from "./card-banner-gatorz.vue?vue&type=script&lang=js&"
export * from "./card-banner-gatorz.vue?vue&type=script&lang=js&"
import style0 from "./card-banner-gatorz.vue?vue&type=style&index=0&id=2a17ff94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a17ff94",
  null
  
)

export default component.exports